import { AssetTrackingData } from '../types/telemetry.types'

/**
 * Standard vehicles always report speed, so speed > 0 is authoritative.
 * Sticker trackers never report speed - fall back to the backend's dwell
 * detection: a `dwellId` means the device has settled into a stationary
 * period, its absence means the device is moving.
 */
export const deriveIsMoving = (current: Pick<AssetTrackingData, 'speed' | 'dwellId'>): boolean => {
  if (current.speed !== undefined) {
    return current.speed > 0
  }

  return current.dwellId === undefined
}
